export const SELECT_SALES_MODES = "SELECT_SALES_MODES";
export const ADD_SALE_MODE = "ADD_SALE_MODE";
export const CLEAR_SALES_MODES = "CLEAR_SALES_MODES";
export const INIT_SALES_MODES = "INIT_SALES_MODES";
export const EMPTY = "EMPTY";
